// import { BrowserRouter as useNavigate } from 'react-router-dom'

export function removeTable(containerId) {
    let container = document.getElementById(containerId);
    if(!container) {
        console.log("Container does not exist: " + containerId);
        return;
    }

    container.replaceChildren();
}

export function buildTable(containerId, columnNames, fieldNames, jsonBody, navigate, idField, basePath, pathAppender = '') {
    console.log("containerId: " + containerId);
    let container = document.getElementById(containerId);
    if(!container) {
        console.log("Container does not exist: " + containerId);
        return;
    }

    // First remove the old table if it exists
    removeTable(containerId);

    let table = document.createElement("table");

    let thead = document.createElement("thead");
    thead.setAttribute("className", "thead-dark");
    let trHeader = document.createElement("tr");
    columnNames.forEach((columnName) => {
        let thColumnName = document.createElement("th");
        thColumnName.innerText = columnName;
        trHeader.appendChild(thColumnName);
    });
    thead.appendChild(trHeader);
    table.append(thead);

    jsonBody.forEach((row) => {
        if (row) {
            let trRow = document.createElement("tr");
            fieldNames.forEach((fieldName) => {
                let tdRowElement = document.createElement("td");
                tdRowElement.innerText = row[fieldName];
                trRow.appendChild(tdRowElement);
            });
            // trRow.innerHTML = "/groups/" + row["name"];
            if(navigate && idField && basePath) {
                trRow.onclick = function () {
                    console.info('Routing to: ' + basePath + row[idField] + pathAppender)
                    navigate(basePath + row[idField] + pathAppender);
                };
            }

            table.appendChild(trRow);
        }
    });
    container.appendChild(table);
}

// export function buildTable(containerId, columnNames, fieldNames, jsonBody, navigate, idField, basePath) {
//     return buildTable(containerId, columnNames, fieldNames, jsonBody, navigate, idField, basePath, '');
// }
